export const SPECS = {
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions'
};
//# sourceMappingURL=SPECS.js.map